import { Ativo, Device, Leitura, buscarAtivos, buscarDevices, buscarLeituras } from "../api/m5";
import { MapaDispositivos, agruparPorTimestamp, criarMapaDispositivos } from "../components/agrupamentoSeries";
import { ValoresSeletor, montarSeletorDados } from "../components/seletorDados";
import { exportarCsv } from "../components/exportarCsv";

export async function montarTabela(container: HTMLElement): Promise<void> {
  container.innerHTML = `
    <div id="filtros-tabela"></div>
    <div class="card">
      <div class="filtros" style="margin-bottom: 12px;">
        <button class="botao secundario" id="tabela-exportar">Exportar CSV</button>
      </div>
      <div style="overflow-x: auto;">
        <table>
          <thead id="tabela-cabecalho"></thead>
          <tbody id="tabela-corpo"></tbody>
        </table>
      </div>
    </div>
  `;

  const [ativos, devices]: [Ativo[], Device[]] = await Promise.all([
    buscarAtivos().catch(() => []),
    buscarDevices().catch(() => []),
  ]);
  const mapaDispositivos: MapaDispositivos = criarMapaDispositivos(devices, ativos);

  let leiturasAtuais: Leitura[] = [];

  async function carregar(filtros: ValoresSeletor) {
    leiturasAtuais = await buscarLeituras({ ...filtros, limit: 200 });
    const linhas = agruparPorTimestamp(leiturasAtuais, mapaDispositivos);
    const colunas = [...new Set(linhas.flatMap((l) => Object.keys(l.valores)))].sort();

    const thead = container.querySelector("#tabela-cabecalho")!;
    thead.innerHTML = `<tr><th>Estação</th><th>Timestamp</th>${colunas.map((c) => `<th>${c}</th>`).join("")}</tr>`;

    const tbody = container.querySelector("#tabela-corpo")!;
    tbody.innerHTML = linhas
      .map((linha) => {
        const celulasValores = colunas.map((c) => `<td>${linha.valores[c] ?? "—"}</td>`).join("");
        return `<tr><td>${linha.estacao}</td><td>${linha.timestamp}</td>${celulasValores}</tr>`;
      })
      .join("");
  }

  container.querySelector("#tabela-exportar")!.addEventListener("click", () => {
    // Exporta o mesmo pivo (estacao + timestamp + colunas por variavel) que
    // aparece na tela, nao as leituras cruas.
    const linhas = agruparPorTimestamp(leiturasAtuais, mapaDispositivos);
    const colunas = [...new Set(linhas.flatMap((l) => Object.keys(l.valores)))].sort();
    const linhasCsv = linhas.map((l) => {
      const linha: Record<string, unknown> = { Estação: l.estacao, Timestamp: l.timestamp };
      for (const c of colunas) linha[c] = l.valores[c] ?? "";
      return linha;
    });
    exportarCsv("leituras.csv", linhasCsv);
  });

  // Por padrao, ao abrir a pagina: TA (temperatura do ar) de todas as
  // estacoes - mesmo criterio de default do Grafico.
  await montarSeletorDados(container.querySelector("#filtros-tabela")!, { tagsPadrao: ["TA"] }, carregar);
}
